import { useRef } from 'react';
import { usePrevious } from '../../../foundation';
/**
 * auto calculate container height
 */
export var useDynamicHeight = function (_a) {
    var itemCount = _a.itemCount, maxContainerHeight = _a.maxContainerHeight, onContainerHeightChange = _a.onContainerHeightChange;
    var prevItemCount = usePrevious(function () { return itemCount; });
    var fullHeight = maxContainerHeight === '100%';
    var maxContainerSize = fullHeight ? -1 : maxContainerHeight;
    var containerHeighRef = useRef(maxContainerSize);
    if (!fullHeight) {
        // * when prev item count is zero, and current is not zero, set hight for vl to trigger totalListHeightChanged to re-change height
        if (prevItemCount === 0 && itemCount !== 0) {
            containerHeighRef.current = maxContainerSize;
        }
        else if (itemCount === 0) {
            // * when item count is zero always height to zero, when zero init
            containerHeighRef.current = 0;
        }
    }
    return {
        containerHeighRef: containerHeighRef,
        totalListHeightChanged: function (height) {
            if (!fullHeight) {
                var containerHeigh = containerHeighRef.current;
                var changeHeight = -1;
                if (height < containerHeigh) {
                    changeHeight = height;
                }
                else if (containerHeigh !== maxContainerSize) {
                    changeHeight = Math.min(height, maxContainerSize);
                }
                if (changeHeight !== -1) {
                    containerHeighRef.current = changeHeight;
                    onContainerHeightChange === null || onContainerHeightChange === void 0 ? void 0 : onContainerHeightChange(changeHeight);
                }
            }
        },
        style: {
            height: fullHeight ? '100%' : containerHeighRef.current,
        },
    };
};
